module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="title-container">\n    <div class="title editable" contenteditable="' +
__e( !readOnly ) +
'">' +
__e( action.name ) +
'</div>\n    <span class="lock-region"></span>\n</div>\n\n';
 if (readOnly) { ;
__p += '\n    <div class="textarea disabled">' +
__e( code ) +
'</div>\n';
 } else { ;
__p += '\n    <div class="info">\n        Add parameters by selecting parts of the code, then click the plus icon; or manually like <tt class="nowrap">#{Parameter name}</tt>.\n    </div>\n    <textarea class="textarea" placeholder="Paste your JavaScript code here..." autofocus>' +
__e( code ) +
'</textarea>\n';
 } ;
__p += '\n\n<h3>Parameters:</h3>\n<ul class="parameter-list">\n    ';
 _.each(action.parameters, function (parameter) { ;
__p += '\n        <li>' +
__e( parameter ) +
'</li>\n    ';
 }); ;
__p += '\n</ul>\n\n<div class="code-error-message"></div>\n\n<div class="actions">\n    <button class="btn btn-grey save-new-custom-js pull-right ladda-button';
 if (readOnly) { ;
__p += ' disabled';
 } ;
__p += '" data-spinner-size="28" data-style="expand-right" ';
 if (readOnly) { ;
__p += 'disabled';
 } ;
__p += '>Save</button>\n    <button class="btn btn-secondary pull-right cancel-new-custom-js">Cancel</button>\n</div>\n\n<span class="plus-icon">+</span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/customJs/editCustomJs/EditCustomJsView.tpl
// module id = 3073
// module chunks = 0